import React, { Component } from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
  // display: flex;
  // align-items: center;
  // flex-wrap: nowrap;
  margin: 0 0 20px;
`;

const Hint = styled.div`
  color: rgba(0,0,0,0.6);
  margin-top: 7px;
`

class Field extends Component {
  render() {
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        required: typeof this.props.required !== 'undefined' ? this.props.required : child.props.required,
        error: typeof this.props.error !== 'undefined' ? this.props.error : child.props.error,
        name: typeof this.props.name !== 'undefined' ? this.props.name : child.props.error,
      })
    )

    return (
      <Wrap {...this.props}>
        {childrenWithProps}
        {this.props.hint && (<Hint>{this.props.hint}</Hint>)}
      </Wrap>
    )
  }
}

export default Field